module.exports = __webpack_public_path__ + "img/ctrl-hadmard-stub-mid-0.fc170927.svg";